/* angular:styles/component:css;21fd9d78f8ac9cf3006db11f9f19aee8d4e0e29819edfec4ac1852b77506dc2c;/builds/4comply/4comply-dashboard/libs/shared/src/lib/ui/flag/flag.component.ts */
.flag {
  border-radius: 2px;
  display: inline-block;
  line-height: 0;
  overflow: hidden;
  vertical-align: middle;
}
/*# sourceMappingURL=flag.component.css.map */
